/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ carrier: NonNullable<unknown>, amount: NonNullable<unknown> }} Orders_Carrier_Rerated_SuccessInputs */

const en_orders_carrier_rerated_success = /** @type {(inputs: Orders_Carrier_Rerated_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.carrier} selected and rerated to ${i?.amount}.`)
};

const es_orders_carrier_rerated_success = /** @type {(inputs: Orders_Carrier_Rerated_SuccessInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Se selecciono ${i?.carrier} y se recalculo a ${i?.amount}.`)
};

/**
* | output |
* | --- |
* | "{carrier} selected and rerated to {amount}." |
*
* @param {Orders_Carrier_Rerated_SuccessInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_carrier_rerated_success = /** @type {((inputs: Orders_Carrier_Rerated_SuccessInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Carrier_Rerated_SuccessInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_carrier_rerated_success(inputs)
	return es_orders_carrier_rerated_success(inputs)
});